<template>
  <div class="car-form-container car-vehicle-identification-vin" data-js="vin-identification">
    <div class="car-vehicle-identification-form">
      <div class="car-form-item car-form-item-vin" :class="{'car-form-item-error': !$v.form.vin.required && $v.form.vin.$error}">
        <label for="vin">{{$t('vinIdentification.vinPlaceholder')}}*</label>
        <input type="text"
               id="vin"
               :class="{ 'car-filled': form.vin }"
               :placeholder="$t('vinIdentification.vinPlaceholder')+'*'"
               v-model="form.vin">
        <div class="car-error-message" v-if="!$v.form.vin.required && $v.form.vin.$error">
          {{$t('vinIdentification.errors.vin')}}
        </div>
      </div>
      <div class="car-form-item car-form-item-year" :class="{'car-form-item-error': !$v.form.year.required && $v.form.year.$error}">
        <label for="year">{{$t('vinIdentification.yearsPlaceholder')}}*</label>
        <div class="car-select-container">
          <select
            name="year"
            v-model="form.year"
            id="year"
            data-js="vin__year--select"
            :class="{ 'car-filled': form.year }"
          >
            <option :value="null">{{ $t('vinIdentification.yearsPlaceholder') }}*</option>
            <option
              v-for="year in years"
              :data-js="'vin__year--option' + year"
              :key="year" :value="year"
            >{{ year }}
            </option>
          </select>
          <div class="car-select-action"></div>
        </div>
        <div class="car-error-message" v-if="!$v.form.year.required && $v.form.year.$error">
          {{$t('vinIdentification.errors.year')}}
        </div>
      </div>
      <div class="car-form-item car-form-item-month" :class="{'car-form-item-error': !$v.form.month.required && $v.form.month.$error}">
        <label for="month">{{$t('vinIdentification.monthsPlaceholder')}}*</label>
        <div class="car-select-container">
          <select
            name="month"
            id="month"
            data-js="vin__month--select"
            v-model="form.month"
            :class="{ 'car-filled': form.month }"
          >
            <option :value="null">{{ $t('vinIdentification.monthsPlaceholder') }}*</option>
            <option
              v-for="(month, monthIndex) in months" :key="month"
              :data-js="'vin__month--option' + monthIndex"
              :value="getMonthIndex(month)"
            >{{ month }}
            </option>
          </select>
          <div class="car-select-action"></div>
        </div>
        <div class="car-error-message" v-if="!$v.form.month.required && $v.form.month.$error">
          {{$t('vinIdentification.errors.month')}}
        </div>
      </div>
      <div class="car-form-item car-form-item-mileage" :class="{'car-form-item-error': !$v.form.mileage.numeric && $v.form.mileage.$error}">
        <label for="mileage">{{$t('vinIdentification.mileagePlaceholder')}}</label>
        <input type="text"
               id="mileage"
               :placeholder="$t('vinIdentification.mileagePlaceholder')"
               :class="{ 'car-filled': form.mileage }"
               v-model="form.mileage">
        <div class="car-error-message" v-if="!$v.form.mileage.numeric && $v.form.mileage.$error">
          {{$t('vinIdentification.errors.mileage')}}
        </div>
      </div>
    </div>
    <div class="car-form-error-message" v-if="$v.form.$error || $v.form.$dirty">{{ $t('errors.unknown') }}</div>
    <div class="car-form-buttons car-buttons">
      <primary-btn
        @click="goNext"
        class="car-btn-primary"
        data-js="vin-identification--btn"
        :loading="loading">
        {{ $t('catalogSelection.mainBtn') }}
      </primary-btn>
      <div class="car-form-required">* {{ $t('catalogSelection.requiredNote') }}</div>
    </div>
  </div>
</template>

<script>
import Moment from 'moment';
import _ from 'lodash';
import regionService from '@/services/regionService';
import smpConfigUtil from '@/util/smp_config_utils';
import PrimaryBtn from '@/components/PrimaryBtn';
import { mapMutations } from 'vuex';
const { required, numeric } = require('vuelidate/lib/validators');

export default {
  name: 'VinSelection',
  data: function() {
    return {
      loading: false,
      form: {
        year: null,
        month: null
      }
    }
  },
  methods: {
    ...mapMutations('vehicleEquipments', {
      setEquipments: 'SET_SELECTED_EQUIPMENTS'
    }),
    setInitialFormData() {
      this.$set(this.form, 'mileage', this.queryPairs.mileage ? this.queryPairs.mileage : this.$store.getters['wizardData/mileage']);
      this.$set(this.form, 'vin', this.queryPairs.vin ? this.queryPairs.vin : this.$store.getters['wizardData/vinIdentificationData'].vin);
      this.$set(this.form, 'month', this.queryPairs.month ? this.queryPairs.month : this.$store.getters['wizardData/vinIdentificationData'].month);
      this.$set(this.form, 'year', this.queryPairs.year ? this.queryPairs.year : this.$store.getters['wizardData/vinIdentificationData'].year);
    },
    goNext() {
      this.$v.$touch();
      if (this.$v.$invalid || this.loading) { return; }
      this.loading = true;
      return this.$store.dispatch('vehicleIdentification/getVinIdentification', this.form)
        .then((res) => {
          this.setEquipments(res.data.equipments);
          this.$store.dispatch('wizardData/setVinData', this.form);
          this.$store.dispatch('wizardData/setMileageData', this.form.mileage);
          regionService.nextRoute(this);
          return res;
        })
        .catch((err) => {
          this.requestError = true;
          return Promise.reject(new Error(err));
        })
        .finally(() => {
          this.loading = false;
        })
    },
    getMonthIndex(monthStr) {
      return Moment().month(monthStr).format('M');
    }
  },
  validations: {
    form: {
      vin: {
        required
      },
      month: {
        required
      },
      year: {
        required
      },
      mileage: {
        numeric
      }
    }
  },
  computed: {
    months: function () {
      return Moment.months()
    },
    // TODO: check if years should be taken from vin response
    years: function () {
      let arr = [];
      for (let i = 1950; i <= Moment().year(); i++) {
        arr.push(i);
      }
      return arr.reverse();
    }
  },
  components: {
    PrimaryBtn
  },
  beforeRouteEnter(to, from, next) {
    return next(vm => {
      if (!smpConfigUtil.isVehicleSelectionMethodAllowed(smpConfigUtil.VEHICLE_SELECTION_VIN)) {
        vm.$router.push({ name: 'VehicleIdentification' });
      } else {
        vm.queryPairs = _.cloneDeep(vm.$route.query);
        vm.setInitialFormData();
      }
    });
  }
}
</script>
